import { useEffect } from "react";

const TRUSTPILOT_SRC = "//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js";

/**
 * Injecte le script du widget Trustpilot dans le <head>, une seule fois par page.
 *
 * Le script n'est volontairement pas injecte pendant le prerendu react-snap :
 * le bootstrap Trustpilot charge un second bundle
 * (widget.trustpilot.com/trustboxes/.../main.js) ecrit en syntaxe ES moderne,
 * que le Chromium embarque par react-snap ne sait pas parser. L'erreur qui en
 * resulte interrompt le crawl et empeche la generation des pages statiques des
 * autres routes.
 */
export function useTrustpilot() {
    useEffect(() => {
        if (navigator.userAgent === "ReactSnap") return;

        const isScriptOnPage = !!document.querySelector(`script[src="${TRUSTPILOT_SRC}"]`);
        if (isScriptOnPage) return;

        const script = document.createElement("script");
        script.type = "text/javascript";
        script.async = true;
        script.src = TRUSTPILOT_SRC;
        document.head.appendChild(script);
    }, []);
}
